import { render } from "./DeliveryModal.vue?vue&type=template&id=255eb182&scoped=true"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"

import "./DeliveryModal.vue?vue&type=style&index=0&id=255eb182&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-255eb182"

export default script